import { Route, X } from 'lucide-react';
import api from '../../lib/api';

export async function fetchLearnerJourney(learnerKey, organizationId) {
  const q = organizationId && organizationId !== 'all' ? `?organization_id=${encodeURIComponent(organizationId)}` : '';
  const r = await api.get(`/segments/learners/${encodeURIComponent(learnerKey)}/journey${q}`);
  return r.data;
}

const fmtDate = (d) => (d ? new Date(d).toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' }) : 'Date unknown');

// Dated timeline of every cohort join + programme entry for one learner.
export default function LearnerJourneyPanel({ journey, onClose, className = '' }) {
  if (!journey) return null;
  return (
    <div className={`rounded-lg border border-teal-200 bg-teal-50/60 p-3 text-xs space-y-2 ${className}`} data-testid="learner-journey-panel">
      <div className="flex items-start justify-between gap-2">
        <p className="font-semibold text-teal-900 inline-flex items-center gap-1.5"><Route className="h-3.5 w-3.5" /> {journey.loading ? 'Loading journey…' : `${journey.learner?.name || journey.learner?.email || journey.learner?.learner_id}`}</p>
        {onClose && <button type="button" onClick={onClose} className="text-slate-400 hover:text-slate-700" data-testid="learner-journey-close"><X className="h-3.5 w-3.5" /></button>}
      </div>
      {!journey.loading && (
        <ol className="relative ml-1.5 border-l border-teal-300 pl-4 space-y-2" data-testid="learner-journey-timeline">
          {journey.timeline.length === 0 && <li className="text-slate-500">No dated memberships yet</li>}
          {journey.timeline.map((e) => (
            <li key={`${e.kind}-${e.id}`} className="relative" data-testid={`learner-journey-event-${e.kind}-${e.id}`}>
              <span className={`absolute -left-[21px] top-1 h-2.5 w-2.5 rounded-full ring-2 ring-white ${e.kind === 'cohort' ? 'bg-teal-500' : 'bg-indigo-500'}`} />
              <p className="text-[10px] uppercase tracking-wide text-slate-500 tabular-nums">{fmtDate(e.date)} · {e.kind === 'cohort' ? 'Joined cohort' : 'Entered programme'}</p>
              <p className="text-slate-800 font-medium">{e.name}{e.detail ? <span className="font-normal text-slate-500"> · {e.detail}</span> : null}</p>
            </li>
          ))}
          <li className="text-[10px] text-slate-500 pt-1" data-testid="learner-journey-summary">{journey.cohorts.length} cohort{journey.cohorts.length === 1 ? '' : 's'} · {journey.programs.length} programme{journey.programs.length === 1 ? '' : 's'}</li>
        </ol>
      )}
    </div>
  );
}
